import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import sidebarMenus from "./menuConfig";
import { hasAnyPermission } from "../../utils/helpers/permissions";

const iconPaths = {
  dashboard: (
    <>
      <path d="M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
      <path d="M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
      <path d="M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
      <path d="M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
    </>
  ),
  master: (
    <>
      <path d="M13 5h8" />
      <path d="M13 9h5" />
      <path d="M13 15h8" />
      <path d="M13 19h5" />
      <path d="M3 4h6v6h-6z" />
      <path d="M3 14h6v6h-6z" />
    </>
  ),
  "user-circle": (
    <>
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
      <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
    </>
  ),
  warehouse: (
    <>
      <path d="M18 21v-10a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v10" />
      <path d="M22 19a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.132 -1.803l7.95 -3.974a2 2 0 0 1 1.837 0l7.948 3.974a2 2 0 0 1 1.133 1.803z" />
      <path d="M6 14h12" />
      <path d="M6 18h12" />
    </>
  ),
  list: (
    <>
      <path d="M5 7h14M5 12h14M5 17h14" />
      <path d="M3 7h.01M3 12h.01M3 17h.01" />
    </>
  ),
  category: (
    <>
      <path d="M4 4h6v6h-6z" />
      <path d="M14 4h6v6h-6z" />
      <path d="M4 14h6v6h-6z" />
      <path d="M14 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
    </>
  ),
  "user-cog": (
    <>
      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
      <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5" />
      <path d="M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M19 15.5v1.5M19 21v1.5M22.032 17.25l-1.299 .75M17.27 20l-1.3 .75" />
    </>
  ),
  "users-group": (
    <>
      <path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
      <path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" />
      <path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0M17 10h2a2 2 0 0 1 2 2v1" />
      <path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0M3 13v-1a2 2 0 0 1 2 -2h2" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3l7 4v5c0 5 -3.5 8.5 -7 9c-3.5 -.5 -7 -4 -7 -9v-5z" />
      <path d="M9 12l2 2l4 -4" />
    </>
  ),
  map: (
    <>
      <path d="M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v13l-6 3z" />
      <path d="M9 4v13M15 7v13" />
    </>
  ),
  users: (
    <>
      <path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
      <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0 -3 -3.85" />
    </>
  ),
  supplier: (
    <>
      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
      <path d="M6 21v-2a4 4 0 0 1 4 -4h3" />
      <path d="M17 17h5M19.5 14.5v5" />
    </>
  ),
  package: (
    <>
      <path d="M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9z" />
      <path d="M12 12l8 -4.5M12 12v9M12 12l-8 -4.5" />
    </>
  ),
  receipt: (
    <>
      <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2z" />
      <path d="M14.8 8a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" />
      <path d="M12 6v10" />
    </>
  ),
  wallet: (
    <>
      <path d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v7a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-10" />
      <path d="M20 12v2h-4a1 1 0 0 1 0 -2h4" />
    </>
  ),
  clipboard: (
    <>
      <path d="M9 5h6a2 2 0 0 1 2 2v1h2a1 1 0 0 1 1 1v11a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-11a1 1 0 0 1 1 -1h2v-1a2 2 0 0 1 2 -2z" />
      <path d="M9 14l2 2l4 -4" />
    </>
  ),
  brain: (
    <>
      <path d="M15.5 13a3.5 3.5 0 0 0 -3.5 -3.5h-1" />
      <path d="M8.5 13a3.5 3.5 0 0 1 3.5 -3.5h1" />
      <path d="M12 5a3 3 0 0 0 -5.92 .67a3 3 0 0 0 -2.08 5.58a3.5 3.5 0 0 0 3.5 5.75h.5a4 4 0 0 0 4 4" />
      <path d="M12 5a3 3 0 0 1 5.92 .67a3 3 0 0 1 2.08 5.58a3.5 3.5 0 0 1 -3.5 5.75h-.5a4 4 0 0 1 -4 4" />
      <path d="M12 5v16" />
    </>
  ),
  product: (
    <>
      <path d="M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2" />
      <path d="M12 15a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M11 7h2" />
    </>
  ),
  "cash-register": (
    <>
      <path d="M4 9h13a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2z" />
      <path d="M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v4M8 14h.01M12 14h.01M16 14h.01M8 17h8" />
    </>
  ),
  "device-desktop": (
    <>
      <path d="M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10" />
      <path d="M7 20h10" />
      <path d="M9 16v4" />
      <path d="M15 16v4" />
    </>
  ),
  store: (
    <>
      <path d="M3 21l18 0" />
      <path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4" />
      <path d="M5 21l0 -10.15" />
      <path d="M19 21l0 -10.15" />
      <path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />
    </>
  ),
  report: (
    <>
      <path d="M4 19V5a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
      <path d="M8 17v-5M12 17v-9M16 17v-3M8 7h2" />
    </>
  ),
};

const SidebarIcon = ({ name, className = "icon icon-tabler icons-tabler-outline" }) => {
  if (!name) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}>
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      {iconPaths[name] || iconPaths.list}
    </svg>
  );
};

const hasPermission = (menu, _permissionSlugs, userProfile) => hasAnyPermission(userProfile, menu.permissions);

const canAccessMenu = (menu, permissionSlugs, userProfile) => {
  if (menu.type === "separator") {
    return true;
  }

  if (menu.children?.length) {
    return (
      (menu.type === "section" || hasPermission(menu, permissionSlugs, userProfile)) &&
      menu.children.some((child) => canAccessMenu(child, permissionSlugs, userProfile))
    );
  }

  return hasPermission(menu, permissionSlugs, userProfile);
};

const isItemActive = (menu, pathname) => {
  if (menu.path) {
    return pathname === menu.path || pathname.startsWith(`${menu.path}/`);
  }

  return menu.children?.some((child) => isItemActive(child, pathname)) || false;
};

const compactMenus = (menus) =>
  menus
    .reduce((result, menu) => {
      if (menu.type === "separator" && (result.length === 0 || result[result.length - 1]?.type === "separator")) {
        return result;
      }

      return [...result, menu];
    }, [])
    .filter((menu, index, collection) => !(menu.type === "separator" && index === collection.length - 1));

const renderDropdownChildren = (menus, pathname, permissionSlugs, userProfile) =>
  menus
    .filter((menu) => canAccessMenu(menu, permissionSlugs, userProfile))
    .map((menu) => {
      if (menu.type === "section") {
        return (
          <div className="akas-sidebar-section" key={menu.title}>
            <div className="akas-sidebar-section-label">{menu.title}</div>
            {renderDropdownChildren(menu.children || [], pathname, permissionSlugs, userProfile)}
          </div>
        );
      }

      if (menu.type === "dropdown") {
        const isActive = isItemActive(menu, pathname);

        return (
          <div className="dropend" key={menu.id || menu.title}>
            <button
              type="button"
              className="dropdown-item dropdown-toggle"
              data-bs-toggle="dropdown"
              data-bs-auto-close="false"
              aria-expanded={isActive}>
              <SidebarIcon name={menu.icon} />
              {menu.title}
            </button>
            <div className={`dropdown-menu ${isActive ? "show" : ""}`}>
              {renderDropdownChildren(menu.children || [], pathname, permissionSlugs, userProfile)}
            </div>
          </div>
        );
      }

      const isActive = isItemActive(menu, pathname);

      return (
        <Link to={menu.path} className={`dropdown-item ${isActive ? "active" : ""}`} key={menu.path}>
          <SidebarIcon name={menu.icon} />
          {menu.title}
        </Link>
      );
    });

const SidebarMenu = ({ pathname, permissions = [], userProfile }) => {
  const permissionSlugs = permissions.map((item) => item?.slug).filter(Boolean);
  const visibleMenus = compactMenus(sidebarMenus.filter((menu) => canAccessMenu(menu, permissionSlugs, userProfile)));
  const activeGroup = visibleMenus.find((menu) => menu.type === "dropdown" && isItemActive(menu, pathname))?.id || null;
  const [expandedGroup, setExpandedGroup] = useState(activeGroup);

  useEffect(() => {
    if (activeGroup) {
      setExpandedGroup(activeGroup);
    }
  }, [activeGroup]);

  return (
    <ul className="navbar-nav pt-lg-0">
      {visibleMenus.map((menu, index) => {
        if (menu.type === "separator") {
          return <hr key={`separator-${index}`} />;
        }

        if (menu.type === "dropdown") {
          const isActive = isItemActive(menu, pathname);
          const isOpen = expandedGroup === menu.id;
          const submenuId = menu.id + "-submenu";

          return (
            <li className={`nav-item dropdown ${isActive ? "active" : ""}`} key={menu.id}>
              <button
                type="button"
                className="nav-link dropdown-toggle"
                aria-label={menu.title}
                aria-expanded={isOpen}
                aria-controls={submenuId}
                onClick={() => setExpandedGroup(isOpen ? null : menu.id)}>
                <span className="nav-link-icon d-inline-block d-flex">
                  <SidebarIcon name={menu.icon} />
                </span>
                <span className="nav-link-title">{menu.title}</span>
              </button>
              <div
                id={submenuId}
                className={"dropdown-menu akas-sidebar-submenu " + (isOpen ? "show" : "")}
                aria-hidden={!isOpen}
                inert={!isOpen}>
                <div className="dropdown-menu-columns">
                  <div className="dropdown-menu-column">
                    {renderDropdownChildren(menu.children || [], pathname, permissionSlugs, userProfile)}
                  </div>
                </div>
              </div>
            </li>
          );
        }

        const isActive = isItemActive(menu, pathname);

        return (
          <li className={`nav-item ${isActive ? "active" : ""}`} key={menu.path}>
            <Link to={menu.path} className="nav-link" aria-label={menu.title}>
              <span className="nav-link-icon d-inline-block d-flex">
                <SidebarIcon name={menu.icon} />
              </span>
              <span className="nav-link-title">{menu.title}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default SidebarMenu;
